import { withSentryReactRouterV6Routing } from '@sentry/react';
import { Routes } from 'react-router-dom';

const SentryRoutes = withSentryReactRouterV6Routing(Routes);

export default SentryRoutes;
